import { meApi, userApi } from './consts';

export var tokenHeader = 'x-access-token';
export var getUserToken = () => {
    return localStorage.getItem('userToken');
}

const apiEndPoint = userApi;

export var currentUser = null;
export var getCurrentUser = async function () {
    if (getUserToken() === null) {
        currentUser = null;
        return currentUser;
    } else if (currentUser !== null) {
        return currentUser;
    } else {
        return fetch(meApi, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                [tokenHeader]: getUserToken()
            }
        })
            .then(res => res.json())
            .then((result) => {
                // console.log("In response:" + JSON.stringify(result));
                currentUser = result;
                return (result);
            })
            .catch(function (error) {
                console.error(error);
                return (null);
            })
    }
};

export var getUsers = () => {
    return fetch(apiEndPoint, {
        headers: {
            [tokenHeader]: getUserToken()
        }
    })
        .then(res => res.json())
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var dateFormat = (dateStr) => {
    let date = new Date(dateStr);
    return date.toLocaleDateString().replaceAll("/", "-");;
} 